import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getMachinePhotos: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.MACHINE_PHOTOS].GET_PHOTOS,
	},
	createMachinePhoto: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MACHINE_PHOTOS].CREATE_PHOTO,
	},
	getMachinePhoto: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MACHINE_PHOTOS].GET_PHOTO,
	},
	patchMachinePhoto: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MACHINE_PHOTOS].PATCH_PHOTO,
	},
	putMachinePhoto: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MACHINE_PHOTOS].PUT_PHOTO,
	},
	deleteMachinePhoto: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MACHINE_PHOTOS].DELETE_PHOTO,
	},
}
